import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import CookiePrivacyPolicyPopup from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import getColor, { getButtonColor, getButtonHover } from "@nishtech/MobiusOverrides/utilities/getColor";
import * as React from "react";
import { css } from "styled-components";

export interface FooterStyles {
    page?: MobiusPageProps;
}

export const footerStyles: FooterStyles = {
    page: {
        css: css`
            a {
                background: unset;
                border: unset;
                cursor: unset;
                display: unset;
                display: unset;
                display: -ms-flexbox;
                display: unset;
                -webkit-align-items: unset;
                -webkit-box-align: unset;
                -ms-flex-align: unset;
                align-items: unset;
                font: unset;
                padding: unset;
                text-align: unset;
                -webkit-text-decoration: unset;
                text-decoration: unset;
            }
            a {
                background-color: transparent;
                color: ${getColor("primary.main")};
                transition: color 0.35s cubic-bezier(0.3, 0.86, 0.36, 0.95);
                -webkit-text-decoration: none;
                text-decoration: none;
                &:hover {
                    -webkit-text-decoration: none;
                    text-decoration: none;
                    color: #c8102e;
                }
                span {
                    background: unset !important;
                    border-radius: unset !important;
                    color: unset !important;
                    font-weight: unset !important;
                }
            }
            img {
                border-style: none;
            }
            * {
                box-sizing: inherit;
            }
            &:after {
                box-sizing: inherit;
            }
            &:before {
                box-sizing: inherit;
            }
            p {
                margin: 0 0 22px;
            }
            ul {
                margin: 0 0 22px;
            }
            h4 {
                color: #013d54;
                font-weight: inherit;
                margin: 0 0 10px;
            }
            .as-container {
                &:after {
                    clear: both;
                    content: "";
                    display: block;
                }
                margin: 0 auto;
                max-width: 1180px;
                padding-left: 20px;
                padding-right: 20px;
                width: 100%;
            }

            background: var(
                --footer-bg-composed,
                var(--footer-bg-color, linear-gradient(to right, ${getColor("secondary.main")}, rgb(4, 35, 89)))
            );
            background-repeat: no-repeat;
            background-size: var(--footer-bg-size, cover);
            background-position: var(--footer-bg-position, center center);

            color: #fff;
            font-size: 18px;
            line-height: 1.2;
            padding: 50px 18px;
            .as-container {
                max-width: 1234px;
            }
            .as-footer-nav-wrap {
                display: flex;
                flex-wrap: wrap;
                margin: 0 -20px 10px;
            }
            .as-footer-area {
                margin: 0 auto;
                max-width: 290px;
                padding: 22px 20px 43px;
                width: 100%;
                .as-btn {
                    display: block;
                    margin-bottom: 26px;
                    padding-left: 5px;
                    padding-right: 5px;
                    text-align: center;
                    &:hover {
                    }
                }
            }
            .as-footer-nav {
                padding: 0 20px 17px;
                width: 100%;
                .as-opener {
                    color: #fff;
                    display: block;
                    position: relative;
                    &:after {
                        background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='17.712' height='10.102'%3E%3Cg data-name='%C3%90%C2%A1%C3%90%C2%B3%C3%91%E2%82%AC%C3%91%C6%92%C3%90%C2%BF%C3%90%C2%BF%C3%90%C2%B8%C3%91%E2%82%AC%C3%90%C2%BE%C3%90%C2%B2%C3%90%C2%B0%C3%91%E2%80%9A%C3%91%C5%92 339'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-width='2' d='m16.298 1.414-7.6 7.288-7.284-7.288' data-name='%C3%90%C5%A1%C3%90%C2%BE%C3%90%C2%BD%C3%91%E2%80%9A%C3%91%C6%92%C3%91%E2%82%AC 14'/%3E%3C/g%3E%3C/svg%3E");
                        background-size: 100% 100%;
                        content: "";
                        height: 10px;
                        position: absolute;
                        right: 0;
                        top: 11px;
                        transition: transform 0.3s ease;
                        width: 17px;
                    }
                }
                h4 {
                    font-size: 23px;
                    font-weight: 700;
                    margin: 0 0 8px;
                }
            }
            .as-nav-slide {
                list-style: none;
                margin: 0;
                padding: 18px 0 0;
                li {
                    margin-bottom: 13px;
                }
                a {
                    color: #fff;
                    transition: color 0.3s ease;
                    cursor: pointer;
                    &:hover {
                        color: #9adbe8;
                    }
                    span {
                        color: unset;
                        &:hover {
                            color: unset;
                        }
                    }
                }
            }
            .as-logo-footer {
                margin: 0 0 21px;
                img {
                    vertical-align: top;
                    width: 100%;
                }
            }
            .as-social-networks {
                display: flex;
                justify-content: space-between;
                list-style: none;
                margin: 0 -1px;
                padding: 0;
                li {
                    margin: 0 5px;
                }
                a {
                    align-items: center;
                    display: flex;
                    height: 30px;
                    justify-content: center;
                    transition: opacity 0.3s ease;
                    width: 30px;
                    &:hover {
                        cursor: pointer;
                        path {
                            fill: #9adbe8;
                        }
                        svg {
                            fill: #9adbe8;
                        }
                    }
                    svg {
                        max-height: 100%;
                        max-width: 100%;
                        transition: fill 0.3s ease;
                        vertical-align: top;
                    }
                    path {
                        transition: fill 0.3s ease;
                    }
                }
            }
            .as-copy {
                font-size: 10px;
                letter-spacing: 0.13px;
                text-align: center;
                p {
                    margin: 0;
                }
            }
            .as-btn {
                color: #fff;
                display: inline-block;
                font-size: 16px;
                letter-spacing: 0.48px;
                line-height: 1.2;
                padding: 13px 23px;
                transition:
                    background 0.3s ease,
                    color 0.3s ease;
                vertical-align: top;
            }
            a.as-btn {
                cursor: pointer;
            }
            .as-btn-primary {
                background: ${p => p.theme?.button?.primary?.backgroundColor};
                color: ${p => p.theme?.button?.primary?.typography?.color || p.theme?.button?.primary?.textColor};
                border: 2px solid ${p => p.theme?.button?.primary?.backgroundColor};

                border-radius: ${p => {
                    const shape = p.theme?.button?.primary?.shape;
                    switch (shape) {
                        case "rounded":
                            return "50px";
                        case "square":
                            return "0px";
                        case "pill":
                            return "9999px";
                        default:
                            return "10px";
                    }
                }};

                font-family: ${p => p.theme?.button?.primary?.typography?.fontFamily};
                font-size: ${p => p.theme?.button?.primary?.typography?.size};
                font-weight: ${p =>
                    p.theme?.button?.primary?.typography?.weight || p.theme?.button?.primary?.typographyProps?.weight};
                line-height: ${p => p.theme?.button?.primary?.typography?.lineHeight};
                letter-spacing: ${p => p.theme?.button?.primary?.typography?.letterSpacing};
                text-transform: ${p => p.theme?.button?.primary?.typography?.textTransform};

                ${p => (p.theme?.button?.primary?.typography?.underline ? "text-decoration: underline;" : "")}
                ${p => (p.theme?.button?.primary?.typography?.italic ? "font-style: italic;" : "")}

    ${p => (p.theme?.button?.primary?.shadow ? "box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);" : "")}

    padding: ${p => {
                    const variant = p.theme?.button?.primary?.sizeVariant;
                    switch (variant) {
                        case "small":
                            return "4px 10px";
                        case "large":
                            return "12px 20px";
                        default:
                            return "8px 16px";
                    }
                }};

                ${p => {
                    const type = p.theme?.button?.primary?.buttonType;
                    const bg = p.theme?.button?.primary?.backgroundColor;
                    const color = p.theme?.button?.primary?.typography?.color || p.theme?.button?.primary?.textColor;
                    if (type === "outline") {
                        return `
                background: transparent;
                border: 2px solid ${bg};
                color: ${color};
            `;
                    }
                    if (type === "ghost") {
                        return `
                background: transparent;
                border: none;
                color: ${color};
            `;
                    }
                    return "";
                }}

                ${p => p.theme?.button?.primary?.css}

    &:hover {
                    background: ${p => p.theme?.button?.primary?.hoverBackgroundColor};
                    border-color: ${p => p.theme?.button?.primary?.hoverBackgroundColor};
                    ${p => p.theme?.button?.primary?.hoverAnimation}
                }
            }

            @media (min-width: 768px) {
                font-size: 16px;
                padding: 60px 0 31px;
                margin-top: 10px;
                .as-footer-area {
                    margin: 0;
                    padding: 0 20px 40px;
                    width: 50%;
                    .as-btn {
                        margin-bottom: 51px;
                    }
                }
                .as-footer-nav {
                    padding: 0 20px 40px;
                    width: 50%;
                    .as-opener {
                        &:after {
                            display: none;
                        }
                    }
                    h4 {
                        font-size: 16px;
                        margin: 0 0 24px;
                        a {
                            pointer-events: none;
                        }
                    }
                }
                .as-nav-slide {
                    padding: 0;
                    li {
                        margin-bottom: 18px;
                    }
                }
                .as-logo-footer {
                    margin: 0 0 46px;
                }
                .as-social-networks {
                    margin: 0 -7px;
                }
                .as-copy {
                    font-size: 13px;
                    text-align: left;
                }
            }
            @media (min-width: 1024px) {
                .as-footer-nav-wrap {
                    flex-wrap: nowrap;
                    margin: 0 -20px 7px;
                }
                .as-footer-area {
                    margin: 0 10px 0 auto;
                    min-width: 244px;
                    padding: 4px 0 0;
                    width: 244px;
                }
                .as-footer-nav {
                    width: 20%;
                }
                .as-footer-nav.as-footer-contact {
                    ul {
                        margin-right: -90px;
                    }
                }
            }
            @media (min-width: 1140px) {
                .as-footer-nav {
                    width: 21.8%;
                }
            }
            @media (min-width: 1366px) {
                .as-copy {
                    margin: 0 -53px;
                }
            }
        `,
    },
};
const styles = footerStyles;

const Footer = (props: PageProps) => {
    const { id } = props;

    const pageFields = (props as any).fields || {};

    const rawBg = typeof pageFields.footerBackgroundColor === "string" ? pageFields.footerBackgroundColor.trim() : "";
    const bgColor =
        rawBg === ""
            ? ""
            : rawBg.startsWith("#") || rawBg.startsWith("rgb") || rawBg.startsWith("hsl")
              ? rawBg
              : `#${rawBg}`;

    let bgImageUrl: string | undefined;
    if (pageFields.footerBackgroundImage) {
        if (typeof pageFields.footerBackgroundImage === "string") {
            bgImageUrl = pageFields.footerBackgroundImage;
        } else if (typeof pageFields.footerBackgroundImage === "object") {
            bgImageUrl =
                pageFields.footerBackgroundImage.url ||
                pageFields.footerBackgroundImage.value ||
                pageFields.footerBackgroundImage.src ||
                undefined;
        }
    }

    const gradient =
        typeof pageFields.footerBackgroundGradient === "string" ? pageFields.footerBackgroundGradient.trim() : "";

    const bgSize =
        typeof pageFields.footerBackgroundSize === "string" && pageFields.footerBackgroundSize.trim() !== ""
            ? pageFields.footerBackgroundSize.trim()
            : "cover";
    const bgPosition =
        typeof pageFields.footerBackgroundPosition === "string" && pageFields.footerBackgroundPosition.trim() !== ""
            ? pageFields.footerBackgroundPosition.trim()
            : "center center";

    let composedBgValue: string | undefined;
    if (gradient && bgImageUrl) {
        composedBgValue = `${gradient}, url("${bgImageUrl}")`;
    } else if (gradient) {
        composedBgValue = gradient;
    } else if (bgImageUrl) {
        composedBgValue = `url("${bgImageUrl}")`;
    } else {
        composedBgValue = undefined;
    }

    const cssVarsStyle: React.CSSProperties = {
        ["--footer-bg-composed" as any]: composedBgValue || undefined,
        ["--footer-bg-color" as any]: bgColor || undefined,
        ["--footer-bg-size" as any]: bgSize,
        ["--footer-bg-position" as any]: bgPosition,
    };

    return (
        <Page as="footer" isFooter={true} {...styles.page} style={cssVarsStyle}>
            <Zone contentId={id} zoneName="Content" />
            <CookiePrivacyPolicyPopup />
        </Page>
    );
};

const pageModule: PageModule = {
    component: Footer,
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
        fieldDefinitions: [
            {
                name: "footerBackgroundColor",
                displayName: "Footer background color (hex or CSS color)",
                editorTemplate: "TextField",
                defaultValue: "#55A9CB",
                fieldType: "General",
                tab: { displayName: "Appearance", sortOrder: 0 },
            },
            {
                name: "footerBackgroundImage",
                displayName: "Footer background image (URL)",
                editorTemplate: "TextField",
                defaultValue: "https://example.com/assets/footer-sample.jpg",
                fieldType: "General",
                tab: { displayName: "Appearance", sortOrder: 0 },
            },
            {
                name: "footerBackgroundGradient",
                displayName: "Footer background gradient (CSS)",
                editorTemplate: "TextField",
                defaultValue: "linear-gradient(to right, rgba(85,169,203,0.95), rgba(4,35,89,0.9))",
                fieldType: "General",
                tab: { displayName: "Appearance", sortOrder: 0 },
            },
            {
                name: "footerBackgroundSize",
                displayName: "Footer background size (e.g. cover)",
                editorTemplate: "TextField",
                defaultValue: "cover",
                fieldType: "General",
                tab: { displayName: "Appearance", sortOrder: 1 },
            },
            {
                name: "footerBackgroundPosition",
                displayName: "Footer background position (e.g. center center)",
                editorTemplate: "TextField",
                defaultValue: "center center",
                fieldType: "General",
                tab: { displayName: "Appearance", sortOrder: 1 },
            },
        ],
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "Footer" instead of this constant.
 */
export const FooterContext = "Footer";
